import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import {
  ConnectedRouter,
  routerMiddleware as createRouterMiddleware
} from "react-router-redux";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";
import Raven from "raven-js";

import { USER_FETCH_REQUESTED } from "./actions.js";
import reducer from "./reducers.js";
import rootSaga from "./sagas.js";
import ToastsContainer from "./containers/ToastsContainer.js";
import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import ProfeShopContainer from "./containers/ProfeShopContainer.js";
import SuggestionsContainer from "./containers/SuggestionsContainer.js";
import ContactUs from "./components/ContactUs.js";
import TermsOfService from "./components/TermsOfService.js";

import "./assets/css/App.css";

// ===== Setup Redux with Router, Sagas, and DevTool.
const history = createBrowserHistory();
const routerMiddleware = createRouterMiddleware(history);
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(routerMiddleware, sagaMiddleware))
);
sagaMiddleware.run(rootSaga);

// ===== Setup Google Analytics
ReactGA.initialize("UA-44364117-1");
history.listen((location, action) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

// ===== Setup Raven
Raven.config("https://c8370390c0d1494f923a61840d3fc679@sentry.io/1208209", {
  release: "0.0.0"
}).install();

class App extends Component {
  componentDidMount() {
    store.dispatch({ type: USER_FETCH_REQUESTED });
  }

  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <ToastsContainer />
            <Navbar />
            <Switch>
              <Route
                exact
                path="/"
                render={() => <Redirect to="/universities/1/search" />}
              />
              <Route
                path="/universities/:universityId"
                component={ProfeShopContainer}
              />
              <Route
                exact
                path="/suggestions/new"
                component={SuggestionsContainer}
              />
              <Route exact path="/contactus" component={ContactUs} />
              <Route exact path="/termsofservice" component={TermsOfService} />
              <Route render={() => <Redirect to="/universities/1/search" />} />
            </Switch>
            <Footer />
          </div>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js